/*
 * Blocks checkout until the customer has accepted the terms.
 *
 * Every form that can reach checkout carries [data-cart-terms-scope] and, while
 * the box is unticked, the class cart-terms-pending. The class is rendered
 * server-side so wallet buttons are already inert on first paint - this file
 * only keeps it in sync afterwards.
 *
 * Listeners are delegated from the document and run in the capture phase: the
 * mini cart is injected after load, and the theme binds its own handlers to
 * those buttons.
 */
(function () {
  'use strict';

  var SCOPE_SELECTOR = '[data-cart-terms-scope]';
  var CHECKOUT_SELECTOR = [
    '[name="checkout"]',
    '.additional-checkout-buttons button',
    '.additional-checkout-buttons a'
  ].join(', ');

  function scopeOf(element) {
    return element && element.closest ? element.closest(SCOPE_SELECTOR) : null;
  }

  function checkboxIn(scope) {
    return scope.querySelector('[data-cart-terms-checkbox]');
  }

  /* No checkbox rendered means the setting is off - nothing to gate. */
  function isAccepted(scope) {
    var checkbox = checkboxIn(scope);
    return !checkbox || checkbox.checked;
  }

  function sync(scope) {
    var accepted = isAccepted(scope);
    var checkbox = checkboxIn(scope);
    var error = scope.querySelector('[data-cart-terms-error]');

    scope.classList.toggle('cart-terms-pending', !accepted);

    if (accepted) {
      if (error) error.hidden = true;
      if (checkbox) checkbox.removeAttribute('aria-invalid');
    }
  }

  function reject(scope) {
    var checkbox = checkboxIn(scope);
    var error = scope.querySelector('[data-cart-terms-error]');

    if (error) error.hidden = false;
    if (checkbox) {
      checkbox.setAttribute('aria-invalid', 'true');
      checkbox.focus();
    }
  }

  function syncAll(root) {
    var scopes = (root || document).querySelectorAll(SCOPE_SELECTOR);
    Array.prototype.forEach.call(scopes, sync);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.closest || !target.closest('[data-cart-terms-checkbox]')) return;

    var scope = scopeOf(target);
    if (scope) sync(scope);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!button) return;

    var scope = scopeOf(button);
    if (!scope || isAccepted(scope)) return;

    event.preventDefault();
    event.stopPropagation();
    reject(scope);
  }, true);

  document.addEventListener('submit', function (event) {
    var scope = scopeOf(event.target);
    if (!scope || isAccepted(scope)) return;

    /*
     * The cart form carries more than the checkout button - a shipping
     * estimate or a quantity update must still go through. A missing
     * submitter means Enter was pressed, which falls back to the first
     * submit button: the checkout one.
     */
    var submitter = event.submitter;
    if (submitter && !submitter.matches(CHECKOUT_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();
    reject(scope);
  }, true);

  /* The mini cart is rendered from a template after load. */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches(SCOPE_SELECTOR)) sync(node);
        syncAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
    });
  } else {
    syncAll();
  }
})();
